import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/membership',
            name: 'membership',
            component: () => import("./views/membership.vue"),
            meta: {
                hasBar: false
            }
        },
        {
            path: '/membership/otpSign',
            name: 'otpSign',
            component: () => import("./views/otpSign.vue"),
            meta: {
                hasBar: false
            }
        }
    ];
};